import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M11.8569 7.08L12.5889 6.398L8.49989 2L4.41089 6.398L5.14289 7.08L7.99989 4.005V17.5C7.99989 17.776 8.22389 18 8.49989 18C8.77589 18 8.99989 17.776 8.99989 17.5V4.007L11.8569 7.08Z"
      fill="currentColor"
    />
    <path
      d="M18.8569 16.92L15.9999 19.994V6.5C15.9999 6.224 15.7759 6 15.4999 6C15.2239 6 14.9999 6.224 14.9999 6.5V19.993L12.1429 16.92L11.4109 17.602L15.4999 22L19.5889 17.602L18.8569 16.92V16.92Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'MobileData');

export default Icon;
